import { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Students from "./pages/Students";
import Committee from "./pages/Committee";
import Certifications from "./pages/Certifications";
import Events from "./pages/Events";
import Contact from "./pages/Contact";
import "./index.css";

export default function App() {
  const [page, setPage] = useState("home");

  const navigate = (p) => {
    setPage(p);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => { window.scrollTo(0, 0); }, [page]);

  const renderPage = () => {
    switch (page) {
      case "home": return <Home onNavigate={navigate} />;
      case "students": return <Students />;
      case "committee": return <Committee />;
      case "certifications": return <Certifications />;
      case "events": return <Events />;
      case "contact": return <Contact />;
      default: return <Home onNavigate={navigate} />;
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Navbar currentPage={page} onNavigate={navigate} />
      <main style={{ flex: 1, paddingTop: page === "home" ? 0 : 68 }}>
        {renderPage()}
      </main>
      <Footer onNavigate={navigate} />
    </div>
  );
}
